module.exports = __webpack_public_path__ + "static/balcony-nav-2438617c02341fbb795414abdee77013.jpeg";